import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';

export const DotDivider = () => <StyledDot>·</StyledDot>;

const StyledDot = styled.div`
  color: ${Color.Gray400};
  line-height: 18px;
`;
